module.exports = __webpack_public_path__ + "static/media/icon_frame_adding_gray.32f58a2b.png";